const fromCalendarAvailabilityByIdQueryToCalendarAvailability = (data) => {
  const perDay = data?.availabilityByStoreCodes[0]?.perDay ?? {};
  return Object.entries(perDay).reduce(
    (acc, [dateString, { slotsAvailable }]) => {
      acc[dateString] = slotsAvailable ? slotsAvailable > 0 : false;
      return acc;
    },
    {}
  );
};
export {
  fromCalendarAvailabilityByIdQueryToCalendarAvailability
};
//# sourceMappingURL=fromCalendarAvailabilityByIdQueryToCalendarAvailability.js.map
